/* eslint-disable no-constant-condition */
import {Edit} from '@mui/icons-material'
import {Box, Checkbox, IconButton, Typography} from '@mui/material'
import React from 'react'
import {CustomButton, CustomTextBox} from '../../../../components'
import MyDiv from './packageForm.style'

export default function PackageForm(props) {
  return (
    <MyDiv>
      <Box className="text_boxes">
        <Typography className="title_text2">Package Name<span> *</span></Typography>
        <CustomTextBox value={props?.packageData?.name} name="name" onChange={props.handleChange}
          error={props.errorData?.name[0]} startIcon={<IconButton tabIndex="-1" className="icn_fix"><Edit className="icn_size" /></IconButton>}
        />
      </Box>
      <Box className="text_boxes">
        <Typography className="title_text2">Price<span> *</span></Typography>
        <CustomTextBox value={props?.packageData?.amount} name="amount" onChange={props.handleChange}
          error={props.errorData?.amount[0]} startIcon={<IconButton tabIndex="-1" className="icn_fix"><Edit className="icn_size" /></IconButton>}
        />
      </Box>
      <Box className="text_boxes2">
        <Typography className="title_text2">Is Promotional?<span> *</span></Typography>
        <Checkbox
          onChange={(e) => props.handleCheckBox(e, props?.packageData?.package_id)}
          checked={props?.packageData?.is_promotional}
        />
      </Box>
      {props.promoFlag ? <Box>
        <Box className="text_boxes">
          <Typography className="title_text2">Promotion Days<span> *</span></Typography>
          <CustomTextBox value={props?.packageData?.promotion_days} name="promotion_days" onChange={props.handleChange}
            error={props.errorData?.promotion_days[0]} startIcon={<IconButton tabIndex="-1" className="icn_fix"><Edit className="icn_size" /></IconButton>}
          />
        </Box>
        <Box className="text_boxes">
          <Typography className="title_text2">Promotion Price<span> *</span></Typography>
          <CustomTextBox value={props?.packageData?.promotion_price} name="promotion_price" onChange={props.handleChange}
            error={props.errorData?.promotion_price[0]} startIcon={<IconButton tabIndex="-1" className="icn_fix"><Edit className="icn_size" /></IconButton>}
          />
        </Box>
      </Box> : null}
      <Box className="flex_btn">
        <CustomButton onClick={props.handleSubmit} className="btn_submit" title="Submit" />
        <CustomButton onClick={props.handleClick} className="btn_cancel" title="Cancel" />
      </Box>
    </MyDiv>
  )
}
